import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var WifiOff = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "wifi-off",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.3119 10a10.999 10.999 0 0 1 3.7681 2.05m3.4999-3.55a16 16 0 0 0-12.3827-3.8955M8.5298 15.61a6.0004 6.0004 0 0 1 6.95 0M12 19.5h.01M1.1934 8.7008A16.0136 16.0136 0 0 1 5.7585 5.763m-1.0265 6.48c1.3974-1.231 3.1098-2.1128 5.0007-2.509m5.9657 6.0411A5.9743 5.9743 0 0 0 11.9999 14.5a5.9747 5.9747 0 0 0-3.7445 1.3116M3 3l18 18"
    })
  }));
};
export default WifiOff;